/**
 * lucy-bundle-promote.js
 * Clones the populated Lucy Bundle widget and injects it into the buy-button zone
 * so users see the bundle offer at the moment of purchase decision.
 * The original widget at the bottom stays as a discovery element.
 */
(function () {
  if (window._lucyBundlePromoteInit) return;
  window._lucyBundlePromoteInit = true;

  var PROMOTED_ID = 'lucy-bundle-widget-promoted';
  var BUY_BTN_SEL = '.product-detail__buy-buttons.button-trigger__sticky';
  var POPULATED_SEL = '.lucy-bundle__card';

  function promote() {
    // Already promoted
    if (document.getElementById(PROMOTED_ID)) return true;

    var original = document.getElementById('lucy-bundle-widget');
    if (!original) return false;

    // Wait until the widget is populated with cards
    if (!original.querySelector(POPULATED_SEL)) return false;

    // Widget is hidden (no bundle data / quota exceeded) — don't promote
    if (original.classList.contains('lucy-bundle--hidden')) return false;

    // Find the buy buttons wrapper
    var buyBtns = document.querySelector(BUY_BTN_SEL);
    if (!buyBtns) return false;

    // Deep clone the populated widget
    var clone = original.cloneNode(true);
    clone.id = PROMOTED_ID;
    clone.style.marginTop = '24px';
    clone.style.marginBottom = '8px';

    // Re-bind CTA on the clone to use the original's handler
    var cloneCta = clone.querySelector('.lucy-bundle__cta');
    if (cloneCta) {
      // Remove the cloned (dead) inline listeners by replacing the node
      var freshCta = cloneCta.cloneNode(true);
      cloneCta.parentNode.replaceChild(freshCta, cloneCta);
      freshCta.addEventListener('click', function (e) {
        e.preventDefault();
        // Delegate to global API — uses the same state as original
        if (window.LucyBundle && window.LucyBundle.addSelectedToCart) {
          // Update this CTA text in sync
          freshCta.textContent = 'Adding...';
          freshCta.disabled = true;
          window.LucyBundle.addSelectedToCart();
          setTimeout(function () {
            freshCta.textContent = '\u2713 Added!';
            setTimeout(function () {
              freshCta.textContent = 'Add Bundle to Cart';
              freshCta.disabled = false;
            }, 2000);
          }, 800);
        }
      });
    }

    // Re-bind card clicks to toggle via global API and sync visuals
    var cloneCards = clone.querySelectorAll('.lucy-bundle__card');
    cloneCards.forEach(function (card, idx) {
      var freshCard = card.cloneNode(true);
      card.parentNode.replaceChild(freshCard, card);
      freshCard.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.LucyBundle && window.LucyBundle.toggleItem) {
          window.LucyBundle.toggleItem(idx);
          // Sync visual state from original
          syncFromOriginal();
        }
      });
    });

    // Insert after buy buttons wrapper
    buyBtns.parentNode.insertBefore(clone, buyBtns.nextSibling);
    return true;
  }

  function syncFromOriginal() {
    var original = document.getElementById('lucy-bundle-widget');
    var promoted = document.getElementById(PROMOTED_ID);
    if (!original || !promoted) return;

    // Sync card selected state
    var origCards = original.querySelectorAll('.lucy-bundle__card');
    var promoCards = promoted.querySelectorAll('.lucy-bundle__card');
    origCards.forEach(function (oc, i) {
      if (promoCards[i]) {
        var isSelected = oc.classList.contains('lucy-bundle__card--selected');
        promoCards[i].classList.toggle('lucy-bundle__card--selected', isSelected);
      }
    });

    // Sync total price
    var origTotal = original.querySelector('.lucy-bundle__total-value');
    var promoTotal = promoted.querySelector('.lucy-bundle__total-value');
    if (origTotal && promoTotal) {
      promoTotal.textContent = origTotal.textContent;
    }

    // Sync CTA text (item count)
    var origCta = original.querySelector('.lucy-bundle__cta');
    var promoCta = promoted.querySelector('.lucy-bundle__cta');
    if (origCta && promoCta && !promoCta.disabled) {
      promoCta.textContent = origCta.textContent;
    }
  }

  // Watch for the bundle widget to be populated
  function observe() {
    var widget = document.getElementById('lucy-bundle-widget');
    if (!widget) {
      // Widget div not in DOM yet — wait and retry
      setTimeout(observe, 500);
      return;
    }

    // Try immediately
    if (promote()) return;

    // Watch for population (childList for new cards, attributes for class changes)
    var observer = new MutationObserver(function () {
      if (promote()) {
        observer.disconnect();
      }
    });
    observer.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    // Fallback timeout — disconnect observer after 30s, then poll every 3s for 60s more
    setTimeout(function () {
      observer.disconnect();
      // Start polling fallback in case bundle loads late (quota refresh, slow API, etc.)
      var pollCount = 0;
      var maxPolls = 20; // 20 * 3s = 60s
      var pollTimer = setInterval(function () {
        pollCount++;
        if (promote() || pollCount >= maxPolls) {
          clearInterval(pollTimer);
        }
      }, 3000);
    }, 30000);
  }

  // Also sync when original widget cards are toggled
  function watchOriginalToggles() {
    var original = document.getElementById('lucy-bundle-widget');
    if (!original) return;
    var observer = new MutationObserver(function () {
      syncFromOriginal();
    });
    observer.observe(original, { attributes: true, subtree: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observe();
      setTimeout(watchOriginalToggles, 3000);
    });
  } else {
    observe();
    setTimeout(watchOriginalToggles, 3000);
  }
})();
